import { useState, useEffect } from 'react';

function usePreviousValue<T>(value: T) {
  // 使用useState来存储当前值和之前的值
  const [currentValue, setCurrentValue] = useState(value);
  const [previousValue, setPreviousValue] = useState(value);

  // 使用useEffect来更新之前的值
  useEffect(() => {
    setPreviousValue(currentValue);
    setCurrentValue(value);
  }, [value]); // 依赖数组确保只有当value变化时才会触发更新

  // 返回当前值和之前的值
  return [currentValue, previousValue];
}

export { usePreviousValue };
